import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";

export default function AdminCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/admin/login", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(m[1]);
    (async () => {
      try {
        const r = await api.post("/auth/session", { session_id }, { withCredentials: true });
        setUser(r.data.user);
        // Clean the URL
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { replace: true, state: { user: r.data.user } });
      } catch (e) {
        const msg = e.response?.data?.detail || "Authentication failed";
        navigate("/admin/login", { replace: true, state: { error: msg } });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-aawta-jet flex items-center justify-center text-white">
      <div className="text-center">
        <div className="inline-block w-12 h-12 border-2 border-aawta-pink border-t-transparent rounded-full animate-spin mb-4" />
        <p className="text-overline text-white/60">Completing sign-in…</p>
      </div>
    </div>
  );
}
